import { gql } from '@apollo/client';

export const resolvePetAdoptionTransferMutation = gql`
  mutation ECOMMERCE_resolvePetAdoptionTransfer($input: ResolvePetAdoptionTransferInput!) {
    resolvePetAdoptionTransfer(input: $input) {
      redirectUrl
      transfer {
        id
        status
      }
    }
  }
`;
